module.exports = __webpack_public_path__ + "static/main-plugin-files-fc08173f9048e3a88e17e6c24301172e.png";